import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";

const AddInvoiceTransaction= ({ isOpen, onRequestClose, invoiceid }) => {
  const navigate = useNavigate();
  
  const date = new Date();
  date.setDate(date.getDate());
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;      

  const url = "/api/invoiceTransactions/create";

  const [modeOfPayments, setModeOfPayments] = useState([]);
  const [loading, setLoading] = useState(false);

  const [transactions, setTransactions] = useState({
    paymentDate:currentDate,
    modeOfPaymentId: "",
    invoiceId:invoiceid,
    referenceNumber:"",
    amount:"",
    notes:""
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;

        const res = await axios.get(
          "/api/modeofpayment",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setModeOfPayments(res.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    };
    fetchData();
  }, []);

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

      axios
        .post(
          url,
           transactions
          ,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          setLoading(false);
          onRequestClose();
          setTransactions("");
          toast("Payment Details Added Successfully");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error);
        });
    
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setTransactions((prevState) => ({
      ...prevState,
      [id]: value,
    }));

  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered >
      <Modal.Header closeButton>
        <Modal.Title>Payment Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-2">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="form-floating-sm mb-2">
                      <label htmlFor="paymentDate">
                        Payment Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        id="paymentDate"
                        type="date"
                        value={transactions.paymentDate}
                        onChange={(e) => {
                          handleChange(e)}}
                        required
                      />
                       
                    </div>
                  </div>
             
                  <div className="row">
                        <div className="form-floating-sm mb-2">
                          <label htmlFor="modeOfPayment">
                            Mode Of Payment <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-select"
                            id="modeOfPaymentId"
                            value={transactions.modeOfPaymentId}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select Mode of payment</option>
                            {modeOfPayments.map((mp) => (
                              <option key={mp.id} value={mp.id}>
                                {mp.paymentType} 
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
            

                <div className="row">
                    <div className="form-floating-sm mb-2">
                      <label htmlFor="referenceNumber">
                        Reference Number <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="referenceNumber"
                        placeholder="Reference Number"
                        value={transactions.referenceNumber}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                  <div className="form-floating-sm mb-2">
                      <label htmlFor="amount">
                        Amount <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="amount"
                        placeholder="0"
                        value={transactions.amount}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                <div className="row">
                    <div className="form-floating-sm mb-2">
                      <label htmlFor="notes">Notes</label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="notes"
                        placeholder="Add Note"
                        rows="2"
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                <div className="form-group mt-2">
                  <Button type="submit" className="btn btn-primary me-4">
                    SAVE
                  </Button>

                  <Button variant="secondary" onClick={onRequestClose}>
                  Close
                </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddInvoiceTransaction;
